// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../public/fondo-bc-horizontal.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container-bc {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(50%, 1fr));
    grid-template-rows: repeat(2, 1fr);
    height: 100vh; 
    position: relative;
    margin: 0 30px;
    overflow: hidden;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-size: 100% 100%;
    background-position: center; 
    background-repeat: no-repeat; 
}

.logoGreen {
    max-width: 300px;
    display: block;
    margin-top: -80px;
    margin-left: 40px;
}

.h5-bc {
    font-size: 16px;
    margin: 40px 0;
}

.popup-content-login {
    background-color: white;
    box-shadow: 0 0 10px rgba(6, 130, 33, 0.731);
    padding: 20px;
    border-radius: 8px;
    position: relative;
    max-width: 500px; 
    text-align: center;
    margin: 430px;
    margin-top: 30px;
    width: 100%;
    height: 50%;
}

.popup-content-login img {
    margin-left: 100px;
    margin-top: 5px;
}

.popup-content-login h2 {
    margin-bottom: 1.5rem; 
}

.popup-content-login .button-large {
    width: 100%; 
    padding: 0.75rem; 
    font-size: 1rem; 
    border-radius: 0.375rem; 
    background-color: #c1eeaa; 
    color: black; 
    border: none; 
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1); 
    cursor: pointer; 
    transition: background-color 0.3s ease; 
}

.popup-content-login .button-large:hover {
    background-color: #c7ee97; 
}

.popup-content-login .form-element {
    width: 90%; 
    padding: 0.75rem; 
    font-size: 1rem;
    border-radius: 0.375rem; 
    border: 1px solid #d1d5db; 
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1); 
    margin-bottom: 0.75rem; 
}

.popup-content-login .form-element-label {
    text-align: left; 
    display: block;
    margin-bottom: 0.5rem; 
    font-size: medium;
    margin-left: 15px;
}

.password-link {
    font-size: 0.875rem; 
    color: #c1eeaa; 
    font-weight: 600; 
    text-decoration: none; 
}

.password-link:hover {
    color: #c7ee97; 
}

.register-link {
    font-size: 0.875rem; 
    color: #318507; 
    font-weight: 600;
    text-decoration: none; 
}

.register-link:hover {
    color: #c7ee97; 
}

.logos-container-bc {
    display: flex;
    justify-content: center;
    padding: 0;
    margin: 0px;
    align-items: center;
    margin-top: 240px;
    margin-left: -600px;
}

.logo-bc {
    width: 40%;
    height: auto;
    margin: 20px -100px;
}

.welcome-screen {
    text-align: center;
    padding: 0px;
}

.welcome-screen h1 {
    font-size: 2rem;
    color: #4CAF50;
}

/* Estilos para pantallas grandes */
@media (min-width: 1920px) {
    .logoGreen {
        max-width: 500px; 
    }
    
    .h5-bc {
        font-size: 24px; 
        margin: 80px 0;
    }
    
    .popup-content-login {
        padding: 30px; 
        margin-left: 570px;
        border-radius: 16px; 
        max-width: 900px;
        height: auto; 
    }
    
    .popup-content-login img {
        margin-left: 250px; 
    }
    
    .popup-content-login h2 {
        margin-bottom: 2.5rem; 
        font-size: 2.5rem; 
    }
    
    .popup-content-login .button-large {
        padding: 1.25rem; 
        font-size: 1.25rem; 
        border-radius: 0.5rem; 
        background-color: #c1eeaa; 
        color: black; 
        border: none; 
        box-shadow: 0 6px 12px rgba(0, 0, 0, 0.3); 
    }
    
    .popup-content-login .form-element {
        padding: 1.25rem; 
        font-size: 1.25rem; 
        border-radius: 0.5rem; 
        border: 1px solid #d1d5db; 
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.3); 
        margin-bottom: 1.25rem; 
    }
    
    .popup-content-login .form-element-label {
        margin-bottom: 0.75rem; 
        font-size: 1.25rem; 
    }

    .welcome-screen {
        padding: 100px; 
    }
    
    .welcome-screen h1 {
        font-size: 4rem; 
    }

    .logos-container-bc {
        margin-top: 450px; 
        margin-left: -850px; 
        flex-wrap: wrap; 
    }

    .logo-bc {
        width: 30%;
        height: auto;
        margin: 10px -120px;
    }
}

/* Estilos para pantallas de 600px o menos */
@media (max-width: 600px) {
    .container-bc {
        display: flex; 
        flex-direction: column;
        justify-content: center; 
        align-items: center; 
        height: 100vh; 
        margin: 0 10px;
    }

    .logoGreen {
        max-width: 80%;
        margin-left: 10px;
        margin-top: -40px;
    }

    .h5-bc {
        font-size: 14px;
        margin: 10px 0;
    }

    .popup-content-login {
        padding: 15px;
        max-width: 90%;
        height: auto;
        margin: auto; 
        /* display: flex; */
        flex-direction: column;
        align-items: center; 
        justify-content: center; 
        margin-top: 150px;
    }

    .popup-content-login img {
        margin-top: 5px;
        margin-left: 40px;
    }

    .popup-content-login h2 {
        font-size: 1.25rem;
    }

    .popup-content-login .button-large,
    .popup-content-login .form-element {
        padding: 0.5rem;
        font-size: 0.875rem;
    }

    .logos-container-bc {
        display: flex;
        justify-content: center;
        padding: 0;
        align-items: center;
        margin-left: 0px;
        margin-bottom: 200px !important;
        margin-top: -100px !important;
    }

    .logo-bc {
        width: 60%;
        height: auto;
        margin: -5px -200px; 
    }
}

@media (max-width: 390px) {
    .container-bc {
        display: flex; 
        flex-direction: column;
        justify-content: center; 
        align-items: center; 
        height: auto; 
        margin: 0 5px;
        background-size: cover;
    }

    .logoGreen {
        max-width: 60%;
        margin-left: 0;
        margin-top: -20px;
    }

    .h5-bc {
        font-size: 12px;
        margin: 10px 0;
    }

    .popup-content-login {
        padding: 10px;
        max-width: 90%;
        height: auto;
        margin: 80px auto; 
    }

    .popup-content-login img {
        margin: 0 auto;
    }

    .popup-content-login h2 {
        font-size: 1rem;
    }

    .popup-content-login .button-large,
    .popup-content-login .form-element {
        padding: 0.5rem;
        font-size: 0.75rem;
    }

    .logos-container-bc {
        display: flex;
        flex-direction: row; 
        justify-content: center; 
        flex-wrap: nowrap; 
        margin: 20px 0;
        overflow-x: auto; 
    }

    .logo-bc {
        height: 20%; 
        width: 40%; 
        margin: 10px; 
    }
}

@media (max-width: 393px) {
    .container-bc {
        display: flex; 
        flex-direction: column;
        justify-content: center; 
        align-items: center; 
        height: auto; 
        margin: 0 5px;
        background-size: cover;
    }

    .logoGreen {
        max-width: 60%;
        margin-left: 0;
        margin-top: -20px;
    }

    .h5-bc {
        font-size: 12px;
        margin: 10px 0;
    }

    .popup-content-login {
        padding: 10px;
        max-width: 90%;
        height: auto;
        margin: 80px auto; 
    }

    .popup-content-login img {
        margin: 0 auto;
    }

    .popup-content-login h2 {
        font-size: 1rem;
    }

    .popup-content-login .button-large,
    .popup-content-login .form-element {
        padding: 0.5rem;
        font-size: 0.75rem;
    }

    .logos-container-bc {
        display: flex;
        flex-direction: row; 
        justify-content: center;
        flex-wrap: nowrap; 
        margin: 20px 0;
        overflow-x: auto; 
    }

    .logo-bc {
        height: 20%; 
        width: 40%; 
        margin: 10px; 
    }
}

@media (min-width: 768px) and (max-width: 1024px) {
    .container-bc {
        background-size: contain; 
        background-position: center;
        width: 100vw; 
        height: 100vh;
    }

    .logoGreen {
        max-width: 250px; 
        margin-bottom: 20px; 
    }
    
    .h5-bc {
        font-size: 20px; 
        margin: 40px 0; 
    }
    
    .popup-content-login {
        padding: 20px; 
        margin: 200px 150px; 
        border-radius: 12px; 
        max-width: 500px;
        height: 50%; 
    }
    
    .popup-content-login img {
        margin: 5px auto; 
    }
    
    .popup-content-login h2 {
        margin-bottom: 2rem; 
        font-size: 2rem; 
    }
    
    .popup-content-login .button-large {
        padding: 1rem; 
        font-size: 1rem; 
        border-radius: 0.375rem; 
        background-color: #c1eeaa; 
        color: black; 
        border: none; 
        box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2); 
    }
    
    .popup-content-login .form-element {
        padding: 1rem; 
        font-size: 1rem; 
        border-radius: 0.375rem; 
        border: 1px solid #d1d5db; 
        box-shadow: 0 1px 2px rgba(0, 0, 0, 0.2); 
        margin-bottom: 1rem; 
    }
    
    .popup-content-login .form-element-label {
        margin-bottom: 0.5rem; 
        font-size: 1rem; 
    }

    .logos-container-bc {
        margin-top: 700px; 
        display: flex;
        justify-content: center; 
        flex-wrap: wrap; 
        transform: translateX(100px); 
    }

    .logo-bc {
        width: 40%;
        margin: -60px -100px;
    }
}

/* Estilos para pantallas de 1492px de ancho */
@media (min-width: 1492px) and (max-width: 1499px) {
    .container-bc {
        grid-template-columns: repeat(auto-fit, minmax(48%, 1fr)); 
        grid-template-rows: repeat(2, 1fr); 
        margin: 0 40px;
    }

    .logoGreen {
        max-width: 350px; 
        margin-top: -70px; 
        margin-left: 50px; 
    }

    .h5-bc {
        font-size: 18px; 
        margin: 50px 0;
    }

    .popup-content-login {
        background-color: white;
        box-shadow: 0 0 10px rgba(6, 130, 33, 0.731);
        padding: 20px;
        border-radius: 8px;
        position: relative;
        max-width: 500px; 
        text-align: center;
        margin: 460px;
        margin-top: 30px;
        width: 100%;
        height: 50%;
    }

    .popup-content-login img {
        margin-left: 100px;
        margin-top: 5px;
    }

    .popup-content-login h2 {
        font-size: 1rem;
    }

    .popup-content-login .button-large {
        width: 100%; 
        padding: 0.75rem; 
        font-size: 1rem; 
        border-radius: 0.375rem; 
        background-color: #c1eeaa; 
        color: black; 
        border: none; 
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1); 
        cursor: pointer; 
        transition: background-color 0.3s ease; 
    }
    
    .popup-content-login .form-element {
        width: 90%; 
        padding: 0.75rem; 
        font-size: 1rem;
        border-radius: 0.375rem; 
        border: 1px solid #d1d5db; 
        box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1); 
        margin-bottom: 0.75rem; 
    }
    
    .popup-content-login .form-element-label {
        text-align: left; 
        display: block;
        margin-bottom: 0.5rem; 
        font-size: medium;
        margin-left: 15px;
    }
    
    .welcome-screen {
        text-align: center;
        padding: 0px;
    }
    .welcome-screen h1 {
        font-size: 2.5rem;
    }

    .logos-container-bc {
        margin-top: 300px; 
        margin-left: -600px; 
        flex-wrap: wrap; 
    }

    .logo-bc {
        width: 30%; 
        margin: -70px; 
    }
}

@media (min-width: 2850px) {
    .logoGreen {
        max-width: 500px; 
    }
    
    .h5-bc {
        font-size: 24px; 
        margin: 80px 0;
    }
    
    .popup-content-login {
        padding: 30px; 
        margin-left: 900px;
        border-radius: 16px; 
        max-width: 940px;
        height: auto; 
        margin-top: 100px;
    }
    
    .popup-content-login img {
        margin-left: 250px; 
    }
    
    .popup-content-login h2 {
        margin-bottom: 2.5rem; 
        font-size: 2.5rem; 
    }
    
    .popup-content-login .button-large {
        padding: 1.25rem; 
        font-size: 1.25rem; 
        border-radius: 0.5rem; 
        background-color: #c1eeaa; 
        color: black; 
        border: none; 
        box-shadow: 0 6px 12px rgba(0, 0, 0, 0.3); 
    }
    
    .popup-content-login .form-element {
        padding: 1.25rem; 
        font-size: 1.25rem; 
        border-radius: 0.5rem; 
        border: 1px solid #d1d5db; 
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.3); 
        margin-bottom: 1.25rem; 
    }
    
    .popup-content-login .form-element-label {
        margin-bottom: 0.75rem; 
        font-size: 1.25rem; 
    }

    .welcome-screen {
        padding: 100px; 
    }
    
    .welcome-screen h1 {
        font-size: 4rem; 
    }

    .logos-container-bc {
        margin-top: 60px; 
        margin-left: -100px; 
        flex-wrap: wrap; 
    }

    .logo-bc {
        width: 30%;
        height: auto;
        margin: 10px -120px;
    }
}

@media (min-width: 1676px) {
    .logoGreen {
        max-width: 300px; 
    }
    
    .h5-bc {
        font-size: 24px; 
        margin: 80px 0;
    }
    
    .popup-content-login {
        padding: 30px; 
        border-radius: 16px; 
        max-width: 700px;
        height: auto; 
    }
    
    .popup-content-login img {
        margin-left: 200px; 
    }
    
    .popup-content-login h2 {
        margin-bottom: 2.5rem; 
        font-size: 2.0rem; 
    }
    
    .popup-content-login .button-large {
        padding: 1.25rem; 
        font-size: 1.25rem; 
        border-radius: 0.5rem; 
        background-color: #c1eeaa; 
        color: black; 
        border: none; 
        box-shadow: 0 6px 12px rgba(0, 0, 0, 0.3); 
    }
    
    .popup-content-login .form-element {
        padding: 1.25rem; 
        font-size: 1rem; 
        border-radius: 0.5rem; 
        border: 1px solid #d1d5db; 
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.3); 
        margin-bottom: 1.25rem; 
    }
    
    .popup-content-login .form-element-label {
        margin-bottom: 0.75rem; 
        font-size: 1.25rem; 
    }

    .welcome-screen {
        padding: 10px; 
    }
    
    .welcome-screen h1 {
        font-size: 4rem; 
    }

    .logos-container-bc {
        margin-top: 400px; 
        margin-left: -800px; 
        flex-wrap: wrap; 
    }

    .logo-bc {
        width: 30%;
        height: auto;
        margin: 10px -120px;
    }
}

@media (min-width: 1900px) {
    .logoGreen {
        max-width: 300px; 
    }
    
    .h5-bc {
        font-size: 24px; 
        margin: 80px 0;
    }
    
    .popup-content-login {
        padding: 30px; 
        margin-left: 530px;
        border-radius: 16px; 
        max-width: 700px;
        height: auto; 
    }
    
    .popup-content-login img {
        margin-left: 200px; 
    }
    
    .popup-content-login h2 {
        margin-bottom: 2.5rem; 
        font-size: 2.5rem; 
    }
    
    .popup-content-login .button-large {
        padding: 1.25rem; 
        font-size: 1.25rem; 
        border-radius: 0.5rem; 
        background-color: #c1eeaa; 
        color: black; 
        border: none; 
        box-shadow: 0 6px 12px rgba(0, 0, 0, 0.3); 
    }
    
    .popup-content-login .form-element {
        padding: 1.25rem; 
        font-size: 1.25rem; 
        border-radius: 0.5rem; 
        border: 1px solid #d1d5db; 
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.3); 
        margin-bottom: 1.25rem; 
    }
    
    .popup-content-login .form-element-label {
        margin-bottom: 0.75rem; 
        font-size: 1.25rem; 
    }

    .welcome-screen {
        padding: 100px; 
    }
    
    .welcome-screen h1 {
        font-size: 4rem; 
    }

    .logos-container-bc {
        margin-top: 500px; 
        margin-left: -900px; 
        flex-wrap: wrap; 
    }

    .logo-bc {
        width: 30%;
        height: auto;
        margin: 10px -120px;
    }
}

@media (min-width: 1769px) {
    .logoGreen {
        max-width: 300px; 
    }
    
    .h5-bc {
        font-size: 24px; 
        margin: 80px 0;
    }
    
    .popup-content-login {
        padding: 30px; 
        margin-left: 530px;
        border-radius: 16px; 
        max-width: 600px;
        height: auto; 
    }
    
    .popup-content-login img {
        margin-left: 150px; 
    }
    
    .popup-content-login h2 {
        margin-bottom: 2.5rem; 
        font-size: 2.5rem; 
    }
    
    .popup-content-login .button-large {
        padding: 1.25rem; 
        font-size: 1.25rem; 
        border-radius: 0.5rem; 
        background-color: #c1eeaa; 
        color: black; 
        border: none; 
        box-shadow: 0 6px 12px rgba(0, 0, 0, 0.3); 
    }
    
    .popup-content-login .form-element {
        padding: 1.25rem; 
        font-size: 1.25rem; 
        border-radius: 0.5rem; 
        border: 1px solid #d1d5db; 
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.3); 
        margin-bottom: 1.25rem; 
    }
    
    .popup-content-login .form-element-label {
        margin-bottom: 0.75rem; 
        font-size: 1.25rem; 
    }

    .welcome-screen {
        padding: 100px; 
    }
    
    .welcome-screen h1 {
        font-size: 4rem; 
    }

    .logos-container-bc {
        margin-top: 400px; 
        margin-left: -900px; 
        flex-wrap: wrap; 
    }

    .logo-bc {
        width: 30%;
        height: auto;
        margin: 10px -120px;
    }
}`, "",{"version":3,"sources":["webpack://./src/css/blockchain.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,yDAAyD;IACzD,kCAAkC;IAClC,aAAa;IACb,kBAAkB;IAClB,cAAc;IACd,gBAAgB;IAChB,yDAA6D;IAC7D,0BAA0B;IAC1B,2BAA2B;IAC3B,4BAA4B;AAChC;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,uBAAuB;IACvB,4CAA4C;IAC5C,aAAa;IACb,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;IAClB,aAAa;IACb,gBAAgB;IAChB,WAAW;IACX,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,eAAe;IACf,uBAAuB;IACvB,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,wCAAwC;IACxC,eAAe;IACf,sCAAsC;AAC1C;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,UAAU;IACV,gBAAgB;IAChB,eAAe;IACf,uBAAuB;IACvB,yBAAyB;IACzB,wCAAwC;IACxC,sBAAsB;AAC1B;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,qBAAqB;IACrB,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,gBAAgB;IAChB,qBAAqB;AACzB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,gBAAgB;IAChB,qBAAqB;AACzB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,UAAU;IACV,WAAW;IACX,mBAAmB;IACnB,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,UAAU;IACV,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA,mCAAmC;AACnC;IACI;QACI,gBAAgB;IACpB;;IAEA;QACI,eAAe;QACf,cAAc;IAClB;;IAEA;QACI,aAAa;QACb,kBAAkB;QAClB,mBAAmB;QACnB,gBAAgB;QAChB,YAAY;IAChB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,qBAAqB;QACrB,iBAAiB;IACrB;;IAEA;QACI,gBAAgB;QAChB,kBAAkB;QAClB,qBAAqB;QACrB,yBAAyB;QACzB,YAAY;QACZ,YAAY;QACZ,yCAAyC;IAC7C;;IAEA;QACI,gBAAgB;QAChB,kBAAkB;QAClB,qBAAqB;QACrB,yBAAyB;QACzB,wCAAwC;QACxC,sBAAsB;IAC1B;;IAEA;QACI,sBAAsB;QACtB,kBAAkB;IACtB;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,iBAAiB;QACjB,mBAAmB;QACnB,eAAe;IACnB;;IAEA;QACI,UAAU;QACV,YAAY;QACZ,mBAAmB;IACvB;AACJ;;AAEA,4CAA4C;AAC5C;IACI;QACI,aAAa;QACb,sBAAsB;QACtB,uBAAuB;QACvB,mBAAmB;QACnB,aAAa;QACb,cAAc;IAClB;;IAEA;QACI,cAAc;QACd,iBAAiB;QACjB,iBAAiB;IACrB;;IAEA;QACI,eAAe;QACf,cAAc;IAClB;;IAEA;QACI,aAAa;QACb,cAAc;QACd,YAAY;QACZ,YAAY;QACZ,mBAAmB;QACnB,sBAAsB;QACtB,mBAAmB;QACnB,uBAAuB;QACvB,iBAAiB;IACrB;;IAEA;QACI,eAAe;QACf,iBAAiB;IACrB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;;QAEI,eAAe;QACf,mBAAmB;IACvB;;IAEA;QACI,aAAa;QACb,uBAAuB;QACvB,UAAU;QACV,mBAAmB;QACnB,gBAAgB;QAChB,+BAA+B;QAC/B,6BAA6B;IACjC;;IAEA;QACI,UAAU;QACV,YAAY;QACZ,mBAAmB;IACvB;AACJ;;AAEA;IACI;QACI,aAAa;QACb,sBAAsB;QACtB,uBAAuB;QACvB,mBAAmB;QACnB,YAAY;QACZ,aAAa;QACb,sBAAsB;IAC1B;;IAEA;QACI,cAAc;QACd,cAAc;QACd,iBAAiB;IACrB;;IAEA;QACI,eAAe;QACf,cAAc;IAClB;;IAEA;QACI,aAAa;QACb,cAAc;QACd,YAAY;QACZ,iBAAiB;IACrB;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,eAAe;IACnB;;IAEA;;QAEI,eAAe;QACf,kBAAkB;IACtB;;IAEA;QACI,aAAa;QACb,mBAAmB;QACnB,uBAAuB;QACvB,iBAAiB;QACjB,cAAc;QACd,gBAAgB;IACpB;;IAEA;QACI,WAAW;QACX,UAAU;QACV,YAAY;IAChB;AACJ;;AAEA;IACI;QACI,aAAa;QACb,sBAAsB;QACtB,uBAAuB;QACvB,mBAAmB;QACnB,YAAY;QACZ,aAAa;QACb,sBAAsB;IAC1B;;IAEA;QACI,cAAc;QACd,cAAc;QACd,iBAAiB;IACrB;;IAEA;QACI,eAAe;QACf,cAAc;IAClB;;IAEA;QACI,aAAa;QACb,cAAc;QACd,YAAY;QACZ,iBAAiB;IACrB;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,eAAe;IACnB;;IAEA;;QAEI,eAAe;QACf,kBAAkB;IACtB;;IAEA;QACI,aAAa;QACb,mBAAmB;QACnB,uBAAuB;QACvB,iBAAiB;QACjB,cAAc;QACd,gBAAgB;IACpB;;IAEA;QACI,WAAW;QACX,UAAU;QACV,YAAY;IAChB;AACJ;;AAEA;IACI;QACI,wBAAwB;QACxB,2BAA2B;QAC3B,YAAY;QACZ,aAAa;IACjB;;IAEA;QACI,gBAAgB;QAChB,mBAAmB;IACvB;;IAEA;QACI,eAAe;QACf,cAAc;IAClB;;IAEA;QACI,aAAa;QACb,mBAAmB;QACnB,mBAAmB;QACnB,gBAAgB;QAChB,WAAW;IACf;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,mBAAmB;QACnB,eAAe;IACnB;;IAEA;QACI,aAAa;QACb,eAAe;QACf,uBAAuB;QACvB,yBAAyB;QACzB,YAAY;QACZ,YAAY;QACZ,wCAAwC;IAC5C;;IAEA;QACI,aAAa;QACb,eAAe;QACf,uBAAuB;QACvB,yBAAyB;QACzB,wCAAwC;QACxC,mBAAmB;IACvB;;IAEA;QACI,qBAAqB;QACrB,eAAe;IACnB;;IAEA;QACI,iBAAiB;QACjB,aAAa;QACb,uBAAuB;QACvB,eAAe;QACf,4BAA4B;IAChC;;IAEA;QACI,UAAU;QACV,oBAAoB;IACxB;AACJ;;AAEA,8CAA8C;AAC9C;IACI;QACI,yDAAyD;QACzD,kCAAkC;QAClC,cAAc;IAClB;;IAEA;QACI,gBAAgB;QAChB,iBAAiB;QACjB,iBAAiB;IACrB;;IAEA;QACI,eAAe;QACf,cAAc;IAClB;;IAEA;QACI,uBAAuB;QACvB,4CAA4C;QAC5C,aAAa;QACb,kBAAkB;QAClB,kBAAkB;QAClB,gBAAgB;QAChB,kBAAkB;QAClB,aAAa;QACb,gBAAgB;QAChB,WAAW;QACX,WAAW;IACf;;IAEA;QACI,kBAAkB;QAClB,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,WAAW;QACX,gBAAgB;QAChB,eAAe;QACf,uBAAuB;QACvB,yBAAyB;QACzB,YAAY;QACZ,YAAY;QACZ,wCAAwC;QACxC,eAAe;QACf,sCAAsC;IAC1C;;IAEA;QACI,UAAU;QACV,gBAAgB;QAChB,eAAe;QACf,uBAAuB;QACvB,yBAAyB;QACzB,wCAAwC;QACxC,sBAAsB;IAC1B;;IAEA;QACI,gBAAgB;QAChB,cAAc;QACd,qBAAqB;QACrB,iBAAiB;QACjB,iBAAiB;IACrB;;IAEA;QACI,kBAAkB;QAClB,YAAY;IAChB;IACA;QACI,iBAAiB;IACrB;;IAEA;QACI,iBAAiB;QACjB,mBAAmB;QACnB,eAAe;IACnB;;IAEA;QACI,UAAU;QACV,aAAa;IACjB;AACJ;;AAEA;IACI;QACI,gBAAgB;IACpB;;IAEA;QACI,eAAe;QACf,cAAc;IAClB;;IAEA;QACI,aAAa;QACb,kBAAkB;QAClB,mBAAmB;QACnB,gBAAgB;QAChB,YAAY;QACZ,iBAAiB;IACrB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,qBAAqB;QACrB,iBAAiB;IACrB;;IAEA;QACI,gBAAgB;QAChB,kBAAkB;QAClB,qBAAqB;QACrB,yBAAyB;QACzB,YAAY;QACZ,YAAY;QACZ,yCAAyC;IAC7C;;IAEA;QACI,gBAAgB;QAChB,kBAAkB;QAClB,qBAAqB;QACrB,yBAAyB;QACzB,wCAAwC;QACxC,sBAAsB;IAC1B;;IAEA;QACI,sBAAsB;QACtB,kBAAkB;IACtB;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,gBAAgB;QAChB,mBAAmB;QACnB,eAAe;IACnB;;IAEA;QACI,UAAU;QACV,YAAY;QACZ,mBAAmB;IACvB;AACJ;;AAEA;IACI;QACI,gBAAgB;IACpB;;IAEA;QACI,eAAe;QACf,cAAc;IAClB;;IAEA;QACI,aAAa;QACb,mBAAmB;QACnB,gBAAgB;QAChB,YAAY;IAChB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,qBAAqB;QACrB,iBAAiB;IACrB;;IAEA;QACI,gBAAgB;QAChB,kBAAkB;QAClB,qBAAqB;QACrB,yBAAyB;QACzB,YAAY;QACZ,YAAY;QACZ,yCAAyC;IAC7C;;IAEA;QACI,gBAAgB;QAChB,eAAe;QACf,qBAAqB;QACrB,yBAAyB;QACzB,wCAAwC;QACxC,sBAAsB;IAC1B;;IAEA;QACI,sBAAsB;QACtB,kBAAkB;IACtB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,iBAAiB;QACjB,mBAAmB;QACnB,eAAe;IACnB;;IAEA;QACI,UAAU;QACV,YAAY;QACZ,mBAAmB;IACvB;AACJ;;AAEA;IACI;QACI,gBAAgB;IACpB;;IAEA;QACI,eAAe;QACf,cAAc;IAClB;;IAEA;QACI,aAAa;QACb,kBAAkB;QAClB,mBAAmB;QACnB,gBAAgB;QAChB,YAAY;IAChB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,qBAAqB;QACrB,iBAAiB;IACrB;;IAEA;QACI,gBAAgB;QAChB,kBAAkB;QAClB,qBAAqB;QACrB,yBAAyB;QACzB,YAAY;QACZ,YAAY;QACZ,yCAAyC;IAC7C;;IAEA;QACI,gBAAgB;QAChB,kBAAkB;QAClB,qBAAqB;QACrB,yBAAyB;QACzB,wCAAwC;QACxC,sBAAsB;IAC1B;;IAEA;QACI,sBAAsB;QACtB,kBAAkB;IACtB;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,iBAAiB;QACjB,mBAAmB;QACnB,eAAe;IACnB;;IAEA;QACI,UAAU;QACV,YAAY;QACZ,mBAAmB;IACvB;AACJ;;AAEA;IACI;QACI,gBAAgB;IACpB;;IAEA;QACI,eAAe;QACf,cAAc;IAClB;;IAEA;QACI,aAAa;QACb,kBAAkB;QAClB,mBAAmB;QACnB,gBAAgB;QAChB,YAAY;IAChB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,qBAAqB;QACrB,iBAAiB;IACrB;;IAEA;QACI,gBAAgB;QAChB,kBAAkB;QAClB,qBAAqB;QACrB,yBAAyB;QACzB,YAAY;QACZ,YAAY;QACZ,yCAAyC;IAC7C;;IAEA;QACI,gBAAgB;QAChB,kBAAkB;QAClB,qBAAqB;QACrB,yBAAyB;QACzB,wCAAwC;QACxC,sBAAsB;IAC1B;;IAEA;QACI,sBAAsB;QACtB,kBAAkB;IACtB;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,iBAAiB;QACjB,mBAAmB;QACnB,eAAe;IACnB;;IAEA;QACI,UAAU;QACV,YAAY;QACZ,mBAAmB;IACvB;AACJ","sourcesContent":[".container-bc {\n    display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(50%, 1fr));\n    grid-template-rows: repeat(2, 1fr);\n    height: 100vh; \n    position: relative;\n    margin: 0 30px;\n    overflow: hidden;\n    background-image: url('../../public/fondo-bc-horizontal.png');\n    background-size: 100% 100%;\n    background-position: center; \n    background-repeat: no-repeat; \n}\n\n.logoGreen {\n    max-width: 300px;\n    display: block;\n    margin-top: -80px;\n    margin-left: 40px;\n}\n\n.h5-bc {\n    font-size: 16px;\n    margin: 40px 0;\n}\n\n.popup-content-login {\n    background-color: white;\n    box-shadow: 0 0 10px rgba(6, 130, 33, 0.731);\n    padding: 20px;\n    border-radius: 8px;\n    position: relative;\n    max-width: 500px; \n    text-align: center;\n    margin: 430px;\n    margin-top: 30px;\n    width: 100%;\n    height: 50%;\n}\n\n.popup-content-login img {\n    margin-left: 100px;\n    margin-top: 5px;\n}\n\n.popup-content-login h2 {\n    margin-bottom: 1.5rem; \n}\n\n.popup-content-login .button-large {\n    width: 100%; \n    padding: 0.75rem; \n    font-size: 1rem; \n    border-radius: 0.375rem; \n    background-color: #c1eeaa; \n    color: black; \n    border: none; \n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1); \n    cursor: pointer; \n    transition: background-color 0.3s ease; \n}\n\n.popup-content-login .button-large:hover {\n    background-color: #c7ee97; \n}\n\n.popup-content-login .form-element {\n    width: 90%; \n    padding: 0.75rem; \n    font-size: 1rem;\n    border-radius: 0.375rem; \n    border: 1px solid #d1d5db; \n    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1); \n    margin-bottom: 0.75rem; \n}\n\n.popup-content-login .form-element-label {\n    text-align: left; \n    display: block;\n    margin-bottom: 0.5rem; \n    font-size: medium;\n    margin-left: 15px;\n}\n\n.password-link {\n    font-size: 0.875rem; \n    color: #c1eeaa; \n    font-weight: 600; \n    text-decoration: none; \n}\n\n.password-link:hover {\n    color: #c7ee97; \n}\n\n.register-link {\n    font-size: 0.875rem; \n    color: #318507; \n    font-weight: 600;\n    text-decoration: none; \n}\n\n.register-link:hover {\n    color: #c7ee97; \n}\n\n.logos-container-bc {\n    display: flex;\n    justify-content: center;\n    padding: 0;\n    margin: 0px;\n    align-items: center;\n    margin-top: 240px;\n    margin-left: -600px;\n}\n\n.logo-bc {\n    width: 40%;\n    height: auto;\n    margin: 20px -100px;\n}\n\n.welcome-screen {\n    text-align: center;\n    padding: 0px;\n}\n\n.welcome-screen h1 {\n    font-size: 2rem;\n    color: #4CAF50;\n}\n\n/* Estilos para pantallas grandes */\n@media (min-width: 1920px) {\n    .logoGreen {\n        max-width: 500px; \n    }\n    \n    .h5-bc {\n        font-size: 24px; \n        margin: 80px 0;\n    }\n    \n    .popup-content-login {\n        padding: 30px; \n        margin-left: 570px;\n        border-radius: 16px; \n        max-width: 900px;\n        height: auto; \n    }\n    \n    .popup-content-login img {\n        margin-left: 250px; \n    }\n    \n    .popup-content-login h2 {\n        margin-bottom: 2.5rem; \n        font-size: 2.5rem; \n    }\n    \n    .popup-content-login .button-large {\n        padding: 1.25rem; \n        font-size: 1.25rem; \n        border-radius: 0.5rem; \n        background-color: #c1eeaa; \n        color: black; \n        border: none; \n        box-shadow: 0 6px 12px rgba(0, 0, 0, 0.3); \n    }\n    \n    .popup-content-login .form-element {\n        padding: 1.25rem; \n        font-size: 1.25rem; \n        border-radius: 0.5rem; \n        border: 1px solid #d1d5db; \n        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.3); \n        margin-bottom: 1.25rem; \n    }\n    \n    .popup-content-login .form-element-label {\n        margin-bottom: 0.75rem; \n        font-size: 1.25rem; \n    }\n\n    .welcome-screen {\n        padding: 100px; \n    }\n    \n    .welcome-screen h1 {\n        font-size: 4rem; \n    }\n\n    .logos-container-bc {\n        margin-top: 450px; \n        margin-left: -850px; \n        flex-wrap: wrap; \n    }\n\n    .logo-bc {\n        width: 30%;\n        height: auto;\n        margin: 10px -120px;\n    }\n}\n\n/* Estilos para pantallas de 600px o menos */\n@media (max-width: 600px) {\n    .container-bc {\n        display: flex; \n        flex-direction: column;\n        justify-content: center; \n        align-items: center; \n        height: 100vh; \n        margin: 0 10px;\n    }\n\n    .logoGreen {\n        max-width: 80%;\n        margin-left: 10px;\n        margin-top: -40px;\n    }\n\n    .h5-bc {\n        font-size: 14px;\n        margin: 10px 0;\n    }\n\n    .popup-content-login {\n        padding: 15px;\n        max-width: 90%;\n        height: auto;\n        margin: auto; \n        /* display: flex; */\n        flex-direction: column;\n        align-items: center; \n        justify-content: center; \n        margin-top: 150px;\n    }\n\n    .popup-content-login img {\n        margin-top: 5px;\n        margin-left: 40px;\n    }\n\n    .popup-content-login h2 {\n        font-size: 1.25rem;\n    }\n\n    .popup-content-login .button-large,\n    .popup-content-login .form-element {\n        padding: 0.5rem;\n        font-size: 0.875rem;\n    }\n\n    .logos-container-bc {\n        display: flex;\n        justify-content: center;\n        padding: 0;\n        align-items: center;\n        margin-left: 0px;\n        margin-bottom: 200px !important;\n        margin-top: -100px !important;\n    }\n\n    .logo-bc {\n        width: 60%;\n        height: auto;\n        margin: -5px -200px; \n    }\n}\n\n@media (max-width: 390px) {\n    .container-bc {\n        display: flex; \n        flex-direction: column;\n        justify-content: center; \n        align-items: center; \n        height: auto; \n        margin: 0 5px;\n        background-size: cover;\n    }\n\n    .logoGreen {\n        max-width: 60%;\n        margin-left: 0;\n        margin-top: -20px;\n    }\n\n    .h5-bc {\n        font-size: 12px;\n        margin: 10px 0;\n    }\n\n    .popup-content-login {\n        padding: 10px;\n        max-width: 90%;\n        height: auto;\n        margin: 80px auto; \n    }\n\n    .popup-content-login img {\n        margin: 0 auto;\n    }\n\n    .popup-content-login h2 {\n        font-size: 1rem;\n    }\n\n    .popup-content-login .button-large,\n    .popup-content-login .form-element {\n        padding: 0.5rem;\n        font-size: 0.75rem;\n    }\n\n    .logos-container-bc {\n        display: flex;\n        flex-direction: row; \n        justify-content: center; \n        flex-wrap: nowrap; \n        margin: 20px 0;\n        overflow-x: auto; \n    }\n\n    .logo-bc {\n        height: 20%; \n        width: 40%; \n        margin: 10px; \n    }\n}\n\n@media (max-width: 393px) {\n    .container-bc {\n        display: flex; \n        flex-direction: column;\n        justify-content: center; \n        align-items: center; \n        height: auto; \n        margin: 0 5px;\n        background-size: cover;\n    }\n\n    .logoGreen {\n        max-width: 60%;\n        margin-left: 0;\n        margin-top: -20px;\n    }\n\n    .h5-bc {\n        font-size: 12px;\n        margin: 10px 0;\n    }\n\n    .popup-content-login {\n        padding: 10px;\n        max-width: 90%;\n        height: auto;\n        margin: 80px auto; \n    }\n\n    .popup-content-login img {\n        margin: 0 auto;\n    }\n\n    .popup-content-login h2 {\n        font-size: 1rem;\n    }\n\n    .popup-content-login .button-large,\n    .popup-content-login .form-element {\n        padding: 0.5rem;\n        font-size: 0.75rem;\n    }\n\n    .logos-container-bc {\n        display: flex;\n        flex-direction: row; \n        justify-content: center;\n        flex-wrap: nowrap; \n        margin: 20px 0;\n        overflow-x: auto; \n    }\n\n    .logo-bc {\n        height: 20%; \n        width: 40%; \n        margin: 10px; \n    }\n}\n\n@media (min-width: 768px) and (max-width: 1024px) {\n    .container-bc {\n        background-size: contain; \n        background-position: center;\n        width: 100vw; \n        height: 100vh;\n    }\n\n    .logoGreen {\n        max-width: 250px; \n        margin-bottom: 20px; \n    }\n    \n    .h5-bc {\n        font-size: 20px; \n        margin: 40px 0; \n    }\n    \n    .popup-content-login {\n        padding: 20px; \n        margin: 200px 150px; \n        border-radius: 12px; \n        max-width: 500px;\n        height: 50%; \n    }\n    \n    .popup-content-login img {\n        margin: 5px auto; \n    }\n    \n    .popup-content-login h2 {\n        margin-bottom: 2rem; \n        font-size: 2rem; \n    }\n    \n    .popup-content-login .button-large {\n        padding: 1rem; \n        font-size: 1rem; \n        border-radius: 0.375rem; \n        background-color: #c1eeaa; \n        color: black; \n        border: none; \n        box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2); \n    }\n    \n    .popup-content-login .form-element {\n        padding: 1rem; \n        font-size: 1rem; \n        border-radius: 0.375rem; \n        border: 1px solid #d1d5db; \n        box-shadow: 0 1px 2px rgba(0, 0, 0, 0.2); \n        margin-bottom: 1rem; \n    }\n    \n    .popup-content-login .form-element-label {\n        margin-bottom: 0.5rem; \n        font-size: 1rem; \n    }\n\n    .logos-container-bc {\n        margin-top: 700px; \n        display: flex;\n        justify-content: center; \n        flex-wrap: wrap; \n        transform: translateX(100px); \n    }\n\n    .logo-bc {\n        width: 40%;\n        margin: -60px -100px;\n    }\n}\n\n/* Estilos para pantallas de 1492px de ancho */\n@media (min-width: 1492px) and (max-width: 1499px) {\n    .container-bc {\n        grid-template-columns: repeat(auto-fit, minmax(48%, 1fr)); \n        grid-template-rows: repeat(2, 1fr); \n        margin: 0 40px;\n    }\n\n    .logoGreen {\n        max-width: 350px; \n        margin-top: -70px; \n        margin-left: 50px; \n    }\n\n    .h5-bc {\n        font-size: 18px; \n        margin: 50px 0;\n    }\n\n    .popup-content-login {\n        background-color: white;\n        box-shadow: 0 0 10px rgba(6, 130, 33, 0.731);\n        padding: 20px;\n        border-radius: 8px;\n        position: relative;\n        max-width: 500px; \n        text-align: center;\n        margin: 460px;\n        margin-top: 30px;\n        width: 100%;\n        height: 50%;\n    }\n\n    .popup-content-login img {\n        margin-left: 100px;\n        margin-top: 5px;\n    }\n\n    .popup-content-login h2 {\n        font-size: 1rem;\n    }\n\n    .popup-content-login .button-large {\n        width: 100%; \n        padding: 0.75rem; \n        font-size: 1rem; \n        border-radius: 0.375rem; \n        background-color: #c1eeaa; \n        color: black; \n        border: none; \n        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1); \n        cursor: pointer; \n        transition: background-color 0.3s ease; \n    }\n    \n    .popup-content-login .form-element {\n        width: 90%; \n        padding: 0.75rem; \n        font-size: 1rem;\n        border-radius: 0.375rem; \n        border: 1px solid #d1d5db; \n        box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1); \n        margin-bottom: 0.75rem; \n    }\n    \n    .popup-content-login .form-element-label {\n        text-align: left; \n        display: block;\n        margin-bottom: 0.5rem; \n        font-size: medium;\n        margin-left: 15px;\n    }\n    \n    .welcome-screen {\n        text-align: center;\n        padding: 0px;\n    }\n    .welcome-screen h1 {\n        font-size: 2.5rem;\n    }\n\n    .logos-container-bc {\n        margin-top: 300px; \n        margin-left: -600px; \n        flex-wrap: wrap; \n    }\n\n    .logo-bc {\n        width: 30%; \n        margin: -70px; \n    }\n}\n\n@media (min-width: 2850px) {\n    .logoGreen {\n        max-width: 500px; \n    }\n    \n    .h5-bc {\n        font-size: 24px; \n        margin: 80px 0;\n    }\n    \n    .popup-content-login {\n        padding: 30px; \n        margin-left: 900px;\n        border-radius: 16px; \n        max-width: 940px;\n        height: auto; \n        margin-top: 100px;\n    }\n    \n    .popup-content-login img {\n        margin-left: 250px; \n    }\n    \n    .popup-content-login h2 {\n        margin-bottom: 2.5rem; \n        font-size: 2.5rem; \n    }\n    \n    .popup-content-login .button-large {\n        padding: 1.25rem; \n        font-size: 1.25rem; \n        border-radius: 0.5rem; \n        background-color: #c1eeaa; \n        color: black; \n        border: none; \n        box-shadow: 0 6px 12px rgba(0, 0, 0, 0.3); \n    }\n    \n    .popup-content-login .form-element {\n        padding: 1.25rem; \n        font-size: 1.25rem; \n        border-radius: 0.5rem; \n        border: 1px solid #d1d5db; \n        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.3); \n        margin-bottom: 1.25rem; \n    }\n    \n    .popup-content-login .form-element-label {\n        margin-bottom: 0.75rem; \n        font-size: 1.25rem; \n    }\n\n    .welcome-screen {\n        padding: 100px; \n    }\n    \n    .welcome-screen h1 {\n        font-size: 4rem; \n    }\n\n    .logos-container-bc {\n        margin-top: 60px; \n        margin-left: -100px; \n        flex-wrap: wrap; \n    }\n\n    .logo-bc {\n        width: 30%;\n        height: auto;\n        margin: 10px -120px;\n    }\n}\n\n@media (min-width: 1676px) {\n    .logoGreen {\n        max-width: 300px; \n    }\n    \n    .h5-bc {\n        font-size: 24px; \n        margin: 80px 0;\n    }\n    \n    .popup-content-login {\n        padding: 30px; \n        border-radius: 16px; \n        max-width: 700px;\n        height: auto; \n    }\n    \n    .popup-content-login img {\n        margin-left: 200px; \n    }\n    \n    .popup-content-login h2 {\n        margin-bottom: 2.5rem; \n        font-size: 2.0rem; \n    }\n    \n    .popup-content-login .button-large {\n        padding: 1.25rem; \n        font-size: 1.25rem; \n        border-radius: 0.5rem; \n        background-color: #c1eeaa; \n        color: black; \n        border: none; \n        box-shadow: 0 6px 12px rgba(0, 0, 0, 0.3); \n    }\n    \n    .popup-content-login .form-element {\n        padding: 1.25rem; \n        font-size: 1rem; \n        border-radius: 0.5rem; \n        border: 1px solid #d1d5db; \n        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.3); \n        margin-bottom: 1.25rem; \n    }\n    \n    .popup-content-login .form-element-label {\n        margin-bottom: 0.75rem; \n        font-size: 1.25rem; \n    }\n\n    .welcome-screen {\n        padding: 10px; \n    }\n    \n    .welcome-screen h1 {\n        font-size: 4rem; \n    }\n\n    .logos-container-bc {\n        margin-top: 400px; \n        margin-left: -800px; \n        flex-wrap: wrap; \n    }\n\n    .logo-bc {\n        width: 30%;\n        height: auto;\n        margin: 10px -120px;\n    }\n}\n\n@media (min-width: 1900px) {\n    .logoGreen {\n        max-width: 300px; \n    }\n    \n    .h5-bc {\n        font-size: 24px; \n        margin: 80px 0;\n    }\n    \n    .popup-content-login {\n        padding: 30px; \n        margin-left: 530px;\n        border-radius: 16px; \n        max-width: 700px;\n        height: auto; \n    }\n    \n    .popup-content-login img {\n        margin-left: 200px; \n    }\n    \n    .popup-content-login h2 {\n        margin-bottom: 2.5rem; \n        font-size: 2.5rem; \n    }\n    \n    .popup-content-login .button-large {\n        padding: 1.25rem; \n        font-size: 1.25rem; \n        border-radius: 0.5rem; \n        background-color: #c1eeaa; \n        color: black; \n        border: none; \n        box-shadow: 0 6px 12px rgba(0, 0, 0, 0.3); \n    }\n    \n    .popup-content-login .form-element {\n        padding: 1.25rem; \n        font-size: 1.25rem; \n        border-radius: 0.5rem; \n        border: 1px solid #d1d5db; \n        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.3); \n        margin-bottom: 1.25rem; \n    }\n    \n    .popup-content-login .form-element-label {\n        margin-bottom: 0.75rem; \n        font-size: 1.25rem; \n    }\n\n    .welcome-screen {\n        padding: 100px; \n    }\n    \n    .welcome-screen h1 {\n        font-size: 4rem; \n    }\n\n    .logos-container-bc {\n        margin-top: 500px; \n        margin-left: -900px; \n        flex-wrap: wrap; \n    }\n\n    .logo-bc {\n        width: 30%;\n        height: auto;\n        margin: 10px -120px;\n    }\n}\n\n@media (min-width: 1769px) {\n    .logoGreen {\n        max-width: 300px; \n    }\n    \n    .h5-bc {\n        font-size: 24px; \n        margin: 80px 0;\n    }\n    \n    .popup-content-login {\n        padding: 30px; \n        margin-left: 530px;\n        border-radius: 16px; \n        max-width: 600px;\n        height: auto; \n    }\n    \n    .popup-content-login img {\n        margin-left: 150px; \n    }\n    \n    .popup-content-login h2 {\n        margin-bottom: 2.5rem; \n        font-size: 2.5rem; \n    }\n    \n    .popup-content-login .button-large {\n        padding: 1.25rem; \n        font-size: 1.25rem; \n        border-radius: 0.5rem; \n        background-color: #c1eeaa; \n        color: black; \n        border: none; \n        box-shadow: 0 6px 12px rgba(0, 0, 0, 0.3); \n    }\n    \n    .popup-content-login .form-element {\n        padding: 1.25rem; \n        font-size: 1.25rem; \n        border-radius: 0.5rem; \n        border: 1px solid #d1d5db; \n        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.3); \n        margin-bottom: 1.25rem; \n    }\n    \n    .popup-content-login .form-element-label {\n        margin-bottom: 0.75rem; \n        font-size: 1.25rem; \n    }\n\n    .welcome-screen {\n        padding: 100px; \n    }\n    \n    .welcome-screen h1 {\n        font-size: 4rem; \n    }\n\n    .logos-container-bc {\n        margin-top: 400px; \n        margin-left: -900px; \n        flex-wrap: wrap; \n    }\n\n    .logo-bc {\n        width: 30%;\n        height: auto;\n        margin: 10px -120px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
